import * as Mod1 from "./discourse/admin-hosted-site-route-map";
import * as Mod2 from "./discourse/components/ca-province-select";
import * as Mod3 from "./discourse/components/country-select";
import * as Mod4 from "./discourse/components/invoice-detail-error";
import * as Mod5 from "./discourse/components/us-state-select";
import * as Mod6 from "./discourse/controllers/admin-invite";
import * as Mod7 from "./discourse/helpers/dollars-and-cents";
import * as Mod8 from "./discourse/hosted-site-route-map";
import * as Mod9 from "./discourse/initializers/admin-sidebar";
import * as Mod10 from "./discourse/initializers/extend-admin-customize";
import * as Mod11 from "./discourse/initializers/extend-admin-start-backup";
import * as Mod12 from "./discourse/initializers/extend-invited";
import * as Mod13 from "./discourse/initializers/lock-ai-spam-toggle";
import * as Mod14 from "./discourse/initializers/open-helper-bot-drawer";
import * as Mod15 from "./discourse/initializers/register-category-type-callback";
import * as Mod16 from "./discourse/initializers/register-category-visibility-callback";
import * as Mod17 from "./discourse/routes/admin-invite";
import * as Mod18 from "./discourse/templates/admin-invite";
import * as Mod19 from "./lib/downgrade";
const compatModules = {
  "discourse/admin-hosted-site-route-map": Mod1,
  "discourse/components/ca-province-select": Mod2,
  "discourse/components/country-select": Mod3,
  "discourse/components/invoice-detail-error": Mod4,
  "discourse/components/us-state-select": Mod5,
  "discourse/controllers/admin-invite": Mod6,
  "discourse/helpers/dollars-and-cents": Mod7,
  "discourse/hosted-site-route-map": Mod8,
  "discourse/initializers/admin-sidebar": Mod9,
  "discourse/initializers/extend-admin-customize": Mod10,
  "discourse/initializers/extend-admin-start-backup": Mod11,
  "discourse/initializers/extend-invited": Mod12,
  "discourse/initializers/lock-ai-spam-toggle": Mod13,
  "discourse/initializers/open-helper-bot-drawer": Mod14,
  "discourse/initializers/register-category-type-callback": Mod15,
  "discourse/initializers/register-category-visibility-callback": Mod16,
  "discourse/routes/admin-invite": Mod17,
  "discourse/templates/admin-invite": Mod18,
  "lib/downgrade": Mod19,
};
export { compatModules };
export default compatModules;
